import useClassNames from '@medflex/hooks/useClassNames';
import * as PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import Textarea from 'react-textarea-autosize';

const MessageComposer = forwardRef(
  (
    {
      inputValue,
      name,
      inputPlaceholder,
      inputMaxRows,
      state,
      children,
      onChange,
      onBlur,
      className,
      files,
      textHidden,
      disabled,
      ...props
    },
    ref,
  ) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const cn = useClassNames(
      () => [
        'flex',
        'min-h-12',
        'pb-0',
        'overflow-hidden',
        'border',
        'border-solid',
        !isFocused && 'border-slate-500',
        isFocused && 'border-blue-500',
        'rounded',
        className,
      ],
      [className, isFocused, state],
    );

    return (
      <div className={cn} data-component="MessageComposer" {...props}>
        <div
          className={`flex flex-col flex-grow overflow-hidden items-start justify-center ${
            textHidden ? 'absolute opacity-0 pointer-events-none' : ''
          }`}
        >
          <Textarea
            className="self-stretch p-2 lg:mr-0 border-0 border-slate-500 focus:border-blue-500 rounded lg:rounded-none resize-none outline-none placeholder-slate-500 whitespace-pre-line webtest-msgInput overflow-x-hidden overflow-y-auto"
            placeholder={inputPlaceholder}
            maxRows={inputMaxRows}
            onFocus={() => setIsFocused(true)}
            onBlur={e => {
              onBlur(e);
              setIsFocused(false);
            }}
            readOnly={state !== 'composing'}
            onChange={event => {
              if (onChange) onChange(event);
              event.preventDefault();
            }}
            disabled={disabled}
            {...(name && { name })}
            {...((inputValue || inputValue === '') && { value: inputValue })}
            ref={ref}
          />
          {files && files}
        </div>
        <div className={`flex self-stretch justify-end ${textHidden ? 'flex-auto' : ''}`}>
          {children}
        </div>
      </div>
    );
  },
);

MessageComposer.propTypes = {
  inputValue: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  inputMaxRows: PropTypes.number,
  state: PropTypes.oneOf(['composing', 'loading']),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  files: PropTypes.node,
  name: PropTypes.string,
  textHidden: PropTypes.bool,
  disabled: PropTypes.bool,
};

MessageComposer.defaultProps = {
  onBlur: () => {},
  onChange: () => {},
  state: 'composing',
  textHidden: false,
};

export default MessageComposer;
